"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = renderDefaultSuggestion;

var _react = _interopRequireDefault(require("react"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _match = _interopRequireDefault(require("autosuggest-highlight/match"));

var _parse = _interopRequireDefault(require("autosuggest-highlight/parse"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function renderDefaultSuggestion(suggestion, _ref) {
  var query = _ref.query,
      isHighlighted = _ref.isHighlighted;
  var matches = (0, _match["default"])(suggestion, query);
  var parts = (0, _parse["default"])(suggestion, matches);
  return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
    selected: isHighlighted,
    component: "div"
  }, parts.map(function (part, index) {
    return part.highlight ? /*#__PURE__*/_react["default"].createElement("strong", {
      key: String(index),
      style: {
        whiteSpace: 'pre'
      }
    }, part.text) : /*#__PURE__*/_react["default"].createElement("span", {
      key: String(index),
      style: {
        whiteSpace: 'pre'
      }
    }, part.text);
  }));
}